var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefundPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2800 2000",
    style: {
      enableBackground: "new 0 0 2800 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.001,
    style: {
      fill: "#FFFFFF"
    },
    width: 2800,
    height: 1999.999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M724.354,287.796c18.125,41.149-0.541,89.2-41.69,107.324c-41.149,18.125-89.2-0.54-107.325-41.69 c-18.124-41.148,0.541-89.2,41.69-107.324C658.179,227.981,706.229,246.646,724.354,287.796z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M670.475,380.397l-6.25-14.191c-8.212,3.45-17.756,4.634-24.222,3.287l-0.774-10.9 c6.544,1.144,15.026,0.595,22.895-2.87c9.976-4.395,14.184-13.127,10.656-21.136c-3.404-7.728-10.988-10.091-23.243-9.728 c-16.808,0.693-28.507-1.872-33.892-14.096c-5.137-11.663-0.746-24.167,11.253-31.968l-6.251-14.191l8.711-3.838l6.003,13.63 c8.555-3.432,15.306-3.722,20.433-3.128l0.572,10.821c-3.693-0.387-10.815-0.941-19.808,3.02 c-10.82,4.766-12.048,13.024-9.572,18.645c3.218,7.306,10.026,8.669,24.479,8.344c17.072-0.474,27.597,3.615,33.105,16.122 c4.89,11.099,1.741,24.901-11.68,33.664l6.436,14.614L670.475,380.397z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M414.173,745.273l-68.685-77.139c0,0,25.263-54.147,99.435-56.07 c45.977-1.19,86.588-47.538,86.588-47.538l69.048,77.548c0,0-44.679,63.554-97.26,64.03 C447.69,706.607,414.173,745.273,414.173,745.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M512.316,638.791c7.203,19.87-5.751,42.789-28.931,51.191 c-23.181,8.404-47.812-0.892-55.015-20.761c-7.203-19.87,5.75-42.789,28.931-51.192 C480.483,609.625,505.114,618.921,512.316,638.791z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M2562,833.083l-33.21-97.803c0,0-59.561-4.741-97.829,58.826 c-23.721,39.404-84.07,51.861-84.07,51.861l33.386,98.319c0,0,77.324-7.506,103.681-53.007 C2511.83,843.159,2562,833.083,2562,833.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M2420.957,865.912c13.729,16.067,40.056,16.109,58.802,0.092 c18.747-16.017,22.813-42.028,9.085-58.096c-13.729-16.068-40.056-16.109-58.802-0.092 C2411.296,823.833,2407.229,849.843,2420.957,865.912z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M2527.965,1901.584c116.008-185.058,235.554-333.1,223.063-595.432 c-10.706-224.813-264.486-289.735-331.867-385.393c-82.465-117.072,14.273-339.003-132.033-538.836 c-160.223-218.843-416.912-214.027-628.047-103.486c-154.18,80.722-312.474,108.518-467.468,60.664 C929.65,258.223,570.701,235.616,535.017,556.777c-24.814,223.326-146.307,292.614-339.003,442.489 c-259.932,202.169-62.128,601.843,38.075,884.314L2527.965,1901.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M2527.965,1901.584H103.159c-6.659,0-12.056-5.398-12.056-12.057v-2.299 c0-6.658,5.398-12.057,12.056-12.057h2424.806c6.658,0,12.056,5.399,12.056,12.057v2.299 C2540.021,1896.186,2534.623,1901.584,2527.965,1901.584z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1621.241,903.964c12.856,43.662-12.118,89.479-55.78,102.335 c-43.662,12.856-89.481-12.118-102.336-55.78c-12.855-43.663,12.119-89.48,55.781-102.336 C1562.568,835.327,1608.385,860.302,1621.241,903.964z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1555.135,989.937l-4.434-15.059c-8.691,2.397-18.428,2.348-24.744,0.157l0.638-11.042 c6.421,1.998,15.008,2.548,23.357,0.089c10.585-3.117,15.942-11.337,13.44-19.835c-2.415-8.2-9.723-11.558-22.072-12.782 c-16.963-1.486-28.375-5.579-32.195-18.55c-3.643-12.375,2.389-24.358,15.446-30.633l-4.435-15.058l9.244-2.723l4.259,14.463 c9.032-2.336,15.849-1.75,20.919-0.489l-0.83,10.938c-3.658-0.868-10.736-2.347-20.279,0.462 c-11.48,3.38-13.784,11.511-12.028,17.476c2.282,7.753,8.94,10.004,23.492,11.553c17.2,1.74,27.235,7.21,31.144,20.48 c3.467,11.779-1.484,25.226-16.096,32.281l4.566,15.506L1555.135,989.937z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3F964F"
    },
    points: "1436.455,1098.861 1336.964,1169.391 1024.096,1391.18 991.702,1414.145 1016.36,1449.23  1153.169,1643.904 1392.405,1473.967 1514.201,1387.451 1515.635,1386.443 1527.973,1229.088  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EAD60"
    },
    d: "M1509.476,1284.992l-61.941-88.139c-21.358,15.01-50.843,9.864-65.857-11.492L1091.644,1391.9 c15.013,21.361,9.865,50.854-11.498,65.866l61.946,88.136c21.361-15.006,50.843-9.863,65.857,11.492l290.033-206.539 C1482.97,1329.494,1488.113,1300.006,1509.476,1284.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F964F"
    },
    d: "M1372.07,1320.209c-24.92-35.461-73.869-44.004-109.33-19.084 c-35.461,24.921-44.005,73.87-19.084,109.33c24.921,35.461,73.87,44.006,109.331,19.084 C1388.448,1404.618,1396.992,1355.67,1372.07,1320.209z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3F964F"
    },
    points: "1527.973,1229.088 1439.4,1313.787 1514.201,1387.451 1515.459,1388.693  1515.636,1386.443  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#193F1E"
    },
    points: "1482.954,1409.412 1439.4,1313.787 1514.201,1387.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#193F1E"
    },
    points: "1527.973,1229.088 1439.4,1313.787 1521.902,1220.45  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#193F1E"
    },
    d: "M1336.964,1169.391l-312.869,221.789l-7.735,58.051l136.809,194.674l239.236-169.938 l-12.217-46.288c-4.616-17.489-35.617-25.218-74.882-20.784L1336.964,1169.391z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 827.604,
    y: 1212.53,
    transform: "matrix(0.1321 -0.9912 0.9912 0.1321 -338.2677 2319.5327)",
    style: {
      fill: "#3F964F"
    },
    width: 655.749,
    height: 280.821
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EAD60"
    },
    d: "M1245.942,1081.924l-106.783-14.234c-3.449,25.877-27.224,44.059-53.101,40.615l-61.664,462.546 c25.881,3.449,44.068,27.229,40.618,53.11l106.783,14.229c3.454-25.875,27.224-44.059,53.101-40.613l61.664-462.547 C1260.68,1131.58,1242.492,1107.805,1245.942,1081.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F964F"
    },
    d: "M1170.958,1277.973c-42.962-5.727-82.431,24.459-88.158,67.42 c-5.726,42.963,24.459,82.432,67.421,88.158c42.962,5.727,82.431-24.459,88.158-67.42 C1244.105,1323.168,1213.92,1283.699,1170.958,1277.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F964F"
    },
    d: "M1255.317,1429.398l-267.461,70.59l71.662,271.524l267.461-70.59l-50.432-191.082 c53.433-14.312,91.915-43.645,86.084-65.738c-5.832-22.094-53.778-28.621-107.314-14.699L1255.317,1429.398z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.348,
    y: 1423.945,
    transform: "matrix(-0.2552 -0.9669 0.9669 -0.2552 25.7191 3178.6399)",
    style: {
      fill: "#4EAD60"
    },
    width: 197.585,
    height: 310.937
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F964F"
    },
    d: "M1201.941,1516.207c-37.432,9.879-59.768,48.232-49.888,85.664s48.232,59.767,85.665,49.887 c37.432-9.879,59.767-48.232,49.888-85.664C1277.726,1528.662,1239.373,1506.326,1201.941,1516.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#193F1E"
    },
    d: "M1255.317,1429.398l-27.396,7.229l71.662,271.523l124.095-32.753l-61.046-231.297 c-5.832-22.094-53.778-28.621-107.314-14.699L1255.317,1429.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F964F"
    },
    d: "M1362.631,1444.101c5.831,22.094-32.65,51.432-86.084,65.738l71.665,271.531l0.008-0.008 c53.428-14.309,91.905-43.644,86.073-65.739L1362.631,1444.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EAD60"
    },
    d: "M1375.563,1493.1c2.579,9.771-4.011,20.701-16.098,29.191c3.582,15.08-4.756,30.137-18.903,33.869 l-0.068,0.019l36.232,137.282l0.068-0.019c12.992-3.429,26.435,3.866,31.895,16.603c12.264-8.517,18.974-19.541,16.375-29.389 L1375.563,1493.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M1044.485,1874.453L651,1874.702c-62.063,0.04-112.406-50.241-112.445-112.304l-0.61-962.908 c-0.039-62.064,50.241-112.407,112.304-112.446l393.485-0.249c62.063-0.04,112.407,50.24,112.446,112.304l0.609,962.909 C1156.829,1824.07,1106.548,1874.414,1044.485,1874.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1048.542,1855.205l-401.618,0.254c-43.643,0.027-79.044-35.33-79.072-78.973l-0.623-984 c-0.027-43.642,35.33-79.045,78.973-79.072l401.618-0.254c43.643-0.027,79.044,35.33,79.072,78.972l0.622,984.001 C1127.542,1819.775,1092.184,1855.178,1048.542,1855.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M534.306,1001.88L534.306,1001.88c-9.683,0-17.533-7.85-17.533-17.533v-90.908 c0-9.684,7.85-17.533,17.533-17.533l0,0c9.684,0,17.534,7.85,17.534,17.533v90.908 C551.839,994.03,543.989,1001.88,534.306,1001.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M1159.548,1001.88L1159.548,1001.88c-9.684,0-17.534-7.85-17.534-17.533v-90.908 c0-9.684,7.85-17.533,17.534-17.533l0,0c9.683,0,17.533,7.85,17.533,17.533v90.908 C1177.082,994.03,1169.231,1001.88,1159.548,1001.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M2109.344,1874.453l-393.486,0.249c-62.063,0.04-112.406-50.241-112.445-112.304l-0.609-962.908 c-0.039-62.064,50.241-112.407,112.304-112.446l393.485-0.249c62.063-0.04,112.406,50.24,112.445,112.304l0.609,962.909 C2221.686,1824.07,2171.406,1874.414,2109.344,1874.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M2113.398,1855.205l-401.617,0.254c-43.644,0.027-79.045-35.33-79.072-78.973l-0.623-984 c-0.027-43.642,35.329-79.045,78.972-79.072l401.618-0.254c43.643-0.027,79.045,35.33,79.072,78.972l0.623,984.001 C2192.398,1819.775,2157.041,1855.178,2113.398,1855.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M1599.163,1001.88L1599.163,1001.88c-9.684,0-17.533-7.85-17.533-17.533v-90.908 c0-9.684,7.85-17.533,17.533-17.533l0,0c9.684,0,17.534,7.85,17.534,17.533v90.908 C1616.697,994.03,1608.847,1001.88,1599.163,1001.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M2224.406,1001.88L2224.406,1001.88c-9.684,0-17.534-7.85-17.534-17.533v-90.908 c0-9.684,7.851-17.533,17.534-17.533l0,0c9.684,0,17.533,7.85,17.533,17.533v90.908 C2241.939,994.03,2234.09,1001.88,2224.406,1001.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M1599.163,1136.354L1599.163,1136.354c-9.684,0-17.533-7.85-17.533-17.533v-90.909 c0-9.683,7.85-17.532,17.533-17.532l0,0c9.684,0,17.534,7.85,17.534,17.532v90.909 C1616.697,1128.504,1608.847,1136.354,1599.163,1136.354z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6A41"
    },
    d: "M353.482,1813.258c-13.221,55.518-60.478,24.982-50.595,60.07 c0.729,2.588,3.187,4.316,5.872,4.418l27.749,1.063c2.677,0.102,5.316-0.662,7.527-2.176 c14.64-10.024,24.572-24.142,56.191-25.855c-0.241-13.498,0.373-32.773-4.087-39.664L353.482,1813.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#201D40"
    },
    d: "M426.609,1423.672c0,0-80.703,123.086-91.844,161.372 c-11.141,38.286,12.165,103.161,7.949,233.906c25.224,6.548,58.855,0.919,58.855,0.919s20.241-163.996-3.567-202.721 c35.673-54.435,125.279-173.273,125.279-173.273L426.609,1423.672z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6A41"
    },
    d: "M471.365,1831.154c-20.535,27.951-71.79,11.42-69.735,48.938 c77.689-1.236,109.983-1.068,109.983-1.068c-0.186-8.619-1.921-29.066-3.79-37.059L471.365,1831.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M447.293,1398.789c0,0-25.734,200.813-19.793,240.242c5.941,39.43,24.345,70.292,24.992,201.103 c25.449,5.606,64.341,10.644,64.341,10.644s16.399-157.773-17.332-201.215c9.56-64.377,55.117-226.303,55.117-226.303 L447.293,1398.789z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4204A"
    },
    d: "M315.457,1310.387l-31.373-35.18c-0.684-0.76-1.651-1.201-2.673-1.219l-25.832-0.153 c-0.736-0.013-3.014,4.071-2.52,4.618l22.129,19.665c0.102,0.112,0.232,0.195,0.379,0.239l37.951,14.08 C314.332,1312.686,316.026,1311.019,315.457,1310.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62552"
    },
    d: "M313.061,1312.744l-29.889-33.167c-0.683-0.759-1.651-1.2-2.673-1.218l-26.631-0.477 c-0.736-0.014-1.132,0.858-0.637,1.403l21.045,23.203c0.103,0.113,0.233,0.195,0.379,0.24l37.538,11.383 C313.007,1314.357,313.631,1313.377,313.061,1312.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M372.115,1342.996L350.5,1332.4c0,0-21.321-21.578-24.487-26.4 c-4.744-2.4-13.717-8.444-15.734-8.674c-2.018-0.231-6.15,0.392-6.15,0.392l10.008,11.385c0,0-4.754,0.943-10.818-2.908 c-6.064-3.853-16.777-14.183-22.023-12.18c-1.861,1.645-1.861,1.645-1.861,1.645s-3.313-3.537-6.436-2.223 c-3.124,1.316,3.087,16.892,20.713,33.402c1.168,4.408,6.976,12.133,6.976,12.133l35.639,12.518L372.115,1342.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4204A"
    },
    d: "M278.304,1284.582c1.266,1.266,3.086,1.498,4.065,0.519c0.979-0.978,0.746-2.8-0.52-4.064 c-1.266-1.268-3.086-1.5-4.065-0.521C276.805,1281.495,277.038,1283.314,278.304,1284.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M472.77,1184.049c-6.414,8.313,43.822,17.352,50.556,0.077 c6.734-17.275-4.831-64.792-4.831-64.792l-45.802,9.723C472.693,1129.057,481.117,1173.23,472.77,1184.049z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M528.513,1080.547c3.856,36.749-16.415,68.996-45.278,72.024 c-28.862,3.029-55.385-24.307-59.242-61.055c-3.856-36.748,16.415-68.994,45.277-72.023 C498.133,1016.464,524.657,1043.799,528.513,1080.547z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.044,1102.335c-1.021,2.844-4.153,4.321-6.997,3.3c-2.843-1.019-4.321-4.152-3.3-6.996 c1.021-2.844,4.153-4.321,6.997-3.301C440.587,1096.359,442.065,1099.492,441.044,1102.335z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476.914,1094.5c-1.104,3.078-4.496,4.678-7.574,3.572c-3.078-1.104-4.677-4.496-3.572-7.573 c1.105-3.077,4.496-4.677,7.574-3.573C476.42,1088.031,478.02,1091.422,476.914,1094.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE623C"
    },
    d: "M451.489,1101.194c-1.159,8.612-2.771,19.21-2.771,19.21s5.66,5.969,15.046,1.842 c-4.694,0.154-9.807-0.738-10.58-6.736C452.412,1109.51,451.489,1101.194,451.489,1101.194z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020205"
    },
    d: "M439.439,1089.845c-0.615,0.368-1.401,0.413-2.077,0.049c-0.067-0.034-2.346-1.198-4.481-0.383 c-1.505,0.574-2.71,2.053-3.58,4.394c-0.404,1.087-1.612,1.641-2.698,1.236c-1.086-0.402-1.64-1.611-1.236-2.697 c1.319-3.55,3.362-5.863,6.075-6.875c3.971-1.482,7.763,0.549,7.922,0.637c1.017,0.555,1.39,1.83,0.835,2.848 C440.014,1089.392,439.747,1089.659,439.439,1089.845z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020205"
    },
    d: "M466.728,1083.865c0.702,0.144,1.459-0.072,1.977-0.639c0.052-0.055,1.821-1.902,4.105-1.836 c1.61,0.047,3.235,1.047,4.827,2.971c0.739,0.895,2.061,1.018,2.955,0.279c0.893-0.738,1.018-2.062,0.279-2.953 c-2.414-2.918-5.105-4.43-7.999-4.493c-4.237-0.093-7.149,3.073-7.271,3.208c-0.777,0.859-0.71,2.188,0.149,2.965 C466.037,1083.626,466.376,1083.791,466.728,1083.865z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020205"
    },
    d: "M517.783,1103.889c-19.014-15.918-13.763-40.238-13.763-40.238 c-9.221,0.604-11.805,4.546-11.805,4.546c-7.413-8.515-5.609-16.532-5.609-16.532c-19.983-2.176-25.833,11.959-41.086,20.299 c-20.888,11.422-50.884,9.943-60.816-16.635c-1.438-3.848,2.216-7.572,6.106-6.256c3.608,1.223,8.114,1.783,13.128,0.281 c0,0-6.103-4.02-8.31-11.26c-1.218-3.994,2.918-7.439,6.711-5.695c5.686,2.614,15.289,3.945,29.877-3.071 c9.71-4.669,28.707-27.355,44.151-28.085c12.626-0.596,24.817,7.002,32.8,20.428c0,0,30.121-4.857,41.746,26.6 c11.421,30.904-31.391,78.648-31.391,78.648S522.809,1108.781,517.783,1103.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M453.815,1136.301c-1.19-0.769-0.895-2.58,0.483-2.917c3.501-0.856,9.247-2.388,14.537-4.37 c5.289-1.983,10.626-4.605,13.827-6.263c1.259-0.651,2.672,0.519,2.281,1.882c-1.201,4.191-4.361,11.055-12.468,14.092 C464.368,1141.764,457.477,1138.67,453.815,1136.301z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M504.245,1082.24c-6.185,6.104-7.151,15.153-2.157,20.215 c4.994,5.062,14.056,4.219,20.242-1.885c6.186-6.102,7.151-15.152,2.156-20.215 C519.493,1075.295,510.431,1076.139,504.245,1082.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE623C"
    },
    d: "M510.255,1099.85c-0.27-0.097-0.521-0.255-0.732-0.475c-3.025-3.172-3.733-7.051-1.892-10.381 c1.886-3.408,5.905-5.34,9.558-4.594c1.028,0.211,1.691,1.215,1.48,2.242c-0.21,1.027-1.214,1.691-2.242,1.481 c-2.001-0.408-4.404,0.781-5.471,2.711c-1.025,1.852-0.558,3.954,1.315,5.917c0.724,0.759,0.696,1.962-0.063,2.687 C511.671,1099.95,510.91,1100.086,510.255,1099.85z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F964F"
    },
    d: "M416.938,1438.414c35.829,7.311,100.248,19.934,134.317,6.651 c12.893-18.51,16.16-123.183,16.16-123.183c3.729-107.739-9.191-123.726-38.329-159.824 c-12.227,5.618-42.832,10.407-56.287,10.513c0,0-30.489,42.328-36.437,73.066c-6.031,31.168-6.714,86.582-7.274,118.323 C428.465,1399.21,421.501,1416.209,416.938,1438.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6A41"
    },
    d: "M533.331,1194.764c20.958,40.797,16.212,85.979-44.726,174.926 c-42.676-3.723-51.045-39.293-51.045-39.293s11.726-44.161,26.957-99.713C479.749,1175.133,524.16,1176.909,533.331,1194.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6A41"
    },
    d: "M347.023,1321.882l91.375,7.292c0,0,39.187-7.148,50.208,40.516 c-19.614,15.269-70.241,20.998-153.282-9.832C344.11,1347.896,347.023,1321.882,347.023,1321.882z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "473.074,1169.547 472.206,1194.123 534.027,1168.203 526.541,1148.322  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M934.477,574.079c-20.202,46.138-73.982,67.163-120.12,46.96 c-46.138-20.202-67.164-73.982-46.961-120.121c20.203-46.137,73.982-67.163,120.12-46.96 C933.654,474.16,954.68,527.94,934.477,574.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M919.559,567.547c-18.002,42.264-71.773,58.044-109.848,32.507 c-24.212-15.776-37.367-45.166-32.83-73.966c7.08-48.569,60.328-77.023,104.103-57.21 C918.24,484.826,936.411,529.774,919.559,567.547z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M845.809,600.482l-0.044-15.507c-8.906-0.129-18.125-2.866-23.51-6.69l3.656-10.298 c5.538,3.67,13.53,6.565,22.128,6.54c10.901-0.03,18.253-6.346,18.229-15.098c-0.024-8.444-6.026-13.648-17.401-18.222 c-15.678-6.098-25.371-13.133-25.408-26.49c-0.036-12.744,8.996-22.442,23.115-24.785l-0.043-15.507l9.519-0.027l0.042,14.893 c9.213,0.281,15.515,2.721,19.975,5.317l-3.81,10.144c-3.23-1.833-9.534-5.193-19.36-5.165 c-11.822,0.034-16.255,7.108-16.238,13.249c0.022,7.985,5.714,11.961,19.088,17.45c15.832,6.404,23.838,14.366,23.877,28.031 c0.034,12.129-8.378,23.515-24.185,26.169l0.045,15.968L845.809,600.482z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1098.073,309.51c-20.203,46.138-73.982,67.164-120.121,46.961 c-46.138-20.202-67.163-73.982-46.96-120.121c20.202-46.139,73.982-67.163,120.12-46.961 C1097.25,209.592,1118.275,263.372,1098.073,309.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1083.154,302.979c-18.002,42.264-71.774,58.044-109.848,32.507 c-24.212-15.776-37.367-45.167-32.83-73.966c7.08-48.57,60.328-77.023,104.103-57.209 C1081.835,220.258,1100.005,265.206,1083.154,302.979z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1009.403,335.914l-0.043-15.507c-8.906-0.129-18.126-2.866-23.511-6.689l3.656-10.298 c5.538,3.67,13.53,6.564,22.128,6.54c10.902-0.03,18.253-6.346,18.229-15.098c-0.024-8.445-6.026-13.648-17.401-18.222 c-15.678-6.098-25.371-13.133-25.408-26.491c-0.036-12.743,8.996-22.442,23.114-24.784l-0.043-15.508l9.519-0.026l0.042,14.894 c9.213,0.281,15.515,2.72,19.975,5.317l-3.81,10.144c-3.229-1.833-9.534-5.193-19.36-5.165 c-11.823,0.033-16.256,7.108-16.238,13.249c0.023,7.984,5.714,11.96,19.087,17.45c15.833,6.404,23.839,14.366,23.878,28.03 c0.034,12.129-8.379,23.515-24.186,26.169l0.045,15.968L1009.403,335.914z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1794.226,309.51c-20.202,46.138-73.981,67.164-120.12,46.961 c-46.139-20.202-67.164-73.982-46.961-120.121c20.202-46.139,73.982-67.163,120.12-46.961 C1793.402,209.592,1814.428,263.372,1794.226,309.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1779.307,302.979c-18.002,42.264-71.773,58.044-109.848,32.507 c-24.212-15.776-37.367-45.167-32.83-73.966c7.08-48.57,60.328-77.023,104.104-57.209 C1777.988,220.258,1796.158,265.206,1779.307,302.979z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1705.557,335.914l-0.043-15.507c-8.906-0.129-18.127-2.866-23.511-6.689l3.655-10.298 c5.538,3.67,13.53,6.564,22.129,6.54c10.9-0.03,18.252-6.346,18.229-15.098c-0.023-8.445-6.027-13.648-17.401-18.222 c-15.679-6.098-25.37-13.133-25.409-26.491c-0.035-12.743,8.996-22.442,23.115-24.784l-0.043-15.508l9.519-0.026l0.041,14.894 c9.213,0.281,15.516,2.72,19.975,5.317l-3.81,10.144c-3.229-1.833-9.534-5.193-19.36-5.165 c-11.822,0.033-16.255,7.108-16.238,13.249c0.023,7.984,5.715,11.96,19.088,17.45c15.833,6.404,23.84,14.366,23.878,28.03 c0.034,12.129-8.379,23.515-24.186,26.169l0.044,15.968L1705.557,335.914z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1980.082,574.079c-20.201,46.138-73.981,67.163-120.119,46.96 c-46.139-20.202-67.164-73.982-46.961-120.121c20.202-46.137,73.982-67.163,120.12-46.96 C1979.26,474.16,2000.285,527.94,1980.082,574.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1965.164,567.547c-18.002,42.264-71.773,58.044-109.848,32.507 c-24.213-15.776-37.367-45.166-32.83-73.966c7.08-48.569,60.328-77.023,104.104-57.21 C1963.846,484.826,1982.016,529.774,1965.164,567.547z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1891.414,600.482l-0.044-15.507c-8.905-0.129-18.126-2.866-23.511-6.69l3.656-10.298 c5.538,3.67,13.53,6.565,22.128,6.54c10.901-0.03,18.253-6.346,18.229-15.098c-0.024-8.444-6.027-13.648-17.401-18.222 c-15.679-6.098-25.371-13.133-25.409-26.49c-0.035-12.744,8.996-22.442,23.115-24.785l-0.043-15.507l9.519-0.027l0.042,14.893 c9.213,0.281,15.516,2.721,19.975,5.317l-3.81,10.144c-3.229-1.833-9.534-5.193-19.36-5.165 c-11.822,0.034-16.255,7.108-16.238,13.249c0.023,7.985,5.715,11.961,19.088,17.45c15.833,6.404,23.84,14.366,23.877,28.031 c0.035,12.129-8.378,23.515-24.185,26.169l0.045,15.968L1891.414,600.482z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1473.092,197.135c-20.201,46.138-73.981,67.164-120.12,46.961 c-46.139-20.203-67.163-73.982-46.961-120.12c20.202-46.139,73.982-67.163,120.12-46.961 C1472.27,97.218,1493.295,150.997,1473.092,197.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1458.174,190.605c-18.002,42.263-71.774,58.044-109.848,32.506 c-24.212-15.776-37.367-45.167-32.83-73.966c7.08-48.569,60.328-77.023,104.104-57.209 C1456.854,107.883,1475.025,152.831,1458.174,190.605z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1384.423,223.54l-0.043-15.507c-8.906-0.129-18.125-2.866-23.51-6.689l3.656-10.298 c5.538,3.67,13.53,6.565,22.128,6.54c10.901-0.03,18.253-6.346,18.229-15.098c-0.024-8.444-6.027-13.648-17.402-18.222 c-15.678-6.098-25.371-13.133-25.408-26.492c-0.036-12.743,8.996-22.441,23.115-24.784l-0.044-15.507l9.52-0.027l0.042,14.893 c9.213,0.282,15.516,2.72,19.975,5.318l-3.81,10.144c-3.229-1.833-9.534-5.193-19.36-5.165 c-11.823,0.033-16.255,7.108-16.238,13.25c0.023,7.984,5.715,11.96,19.088,17.45c15.832,6.404,23.839,14.365,23.877,28.03 c0.035,12.129-8.378,23.516-24.185,26.17l0.045,15.968L1384.423,223.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1751.224,680.105c-4.418,0-8-3.582-8-8c0-6.515-0.168-13.105-0.498-19.586 c-0.226-4.413,3.169-8.172,7.582-8.397c4.405-0.214,8.172,3.169,8.396,7.583c0.345,6.75,0.52,13.615,0.52,20.401 C1759.224,676.523,1755.642,680.105,1751.224,680.105z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1746.544,619.848c-3.873,0-7.276-2.818-7.894-6.764c-2.037-13.01-4.788-26.054-8.178-38.768 c-1.138-4.269,1.4-8.652,5.67-9.791c4.274-1.139,8.653,1.401,9.791,5.67c3.533,13.254,6.401,26.852,8.523,40.414 c0.684,4.366-2.301,8.458-6.666,9.142C1747.372,619.816,1746.955,619.848,1746.544,619.848z M982.96,619.51 c-0.414,0-0.832-0.031-1.254-0.098c-4.365-0.688-7.346-4.783-6.659-9.148c2.137-13.568,5.018-27.162,8.562-40.408 c1.142-4.268,5.527-6.801,9.796-5.659c4.268,1.142,6.802,5.528,5.66,9.796c-3.4,12.704-6.163,25.745-8.212,38.759 C990.232,616.696,986.83,619.51,982.96,619.51z M1725.723,541.746c-3.218,0-6.251-1.954-7.472-5.138 c-4.714-12.291-10.139-24.473-16.124-36.209c-2.007-3.936-0.443-8.753,3.492-10.761c3.936-2.009,8.753-0.444,10.762,3.491 c6.239,12.235,11.895,24.935,16.81,37.75c1.582,4.125-0.479,8.752-4.604,10.333 C1727.644,541.575,1726.674,541.746,1725.723,541.746z M1003.844,541.445c-0.954,0-1.925-0.172-2.869-0.534 c-4.124-1.586-6.182-6.214-4.597-10.338c4.918-12.793,10.579-25.479,16.824-37.703c2.009-3.935,6.828-5.497,10.763-3.484 c3.935,2.009,5.495,6.829,3.485,10.763c-5.991,11.726-11.42,23.893-16.138,36.165 C1010.09,539.494,1007.059,541.445,1003.844,541.445z M1689.009,469.722c-2.617,0-5.183-1.282-6.715-3.64 c-7.171-11.03-15.013-21.816-23.311-32.06c-2.78-3.432-2.252-8.471,1.182-11.251c3.433-2.782,8.471-2.252,11.252,1.181 c8.646,10.674,16.818,21.915,24.291,33.41c2.408,3.704,1.357,8.659-2.347,11.068 C1692.015,469.303,1690.503,469.722,1689.009,469.722z M1040.587,469.501c-1.497,0-3.01-0.418-4.358-1.296 c-3.703-2.41-4.75-7.366-2.339-11.069c7.48-11.489,15.657-22.719,24.305-33.381c2.783-3.432,7.82-3.958,11.253-1.173 c3.432,2.784,3.956,7.821,1.173,11.253c-8.298,10.23-16.146,21.008-23.323,32.032 C1045.765,468.221,1043.202,469.501,1040.587,469.501z M1638.123,406.911c-2.049,0-4.097-0.782-5.66-2.346 c-9.308-9.314-19.211-18.244-29.433-26.538c-3.431-2.784-3.955-7.823-1.171-11.253c2.783-3.43,7.821-3.957,11.253-1.171 c10.65,8.643,20.97,17.946,30.67,27.653c3.123,3.126,3.121,8.19-0.004,11.314 C1642.215,406.13,1640.169,406.911,1638.123,406.911z M1091.5,406.739c-2.048,0-4.097-0.782-5.659-2.345 c-3.123-3.125-3.122-8.19,0.003-11.313c9.707-9.704,20.033-19.002,30.691-27.638c3.433-2.78,8.47-2.253,11.252,1.179 c2.781,3.433,2.254,8.471-1.179,11.253c-10.228,8.288-20.138,17.211-29.454,26.522 C1095.593,405.958,1093.546,406.739,1091.5,406.739z M1575.359,355.999c-1.496,0-3.01-0.419-4.357-1.298 c-11.035-7.185-22.568-13.865-34.28-19.85c-3.935-2.011-5.493-6.831-3.482-10.764c2.009-3.935,6.825-5.495,10.764-3.483 c12.208,6.239,24.229,13.201,35.729,20.69c3.703,2.411,4.75,7.367,2.339,11.07 C1580.538,354.718,1577.975,355.999,1575.359,355.999z M1154.311,355.855c-2.617,0-5.181-1.281-6.714-3.639 c-2.409-3.704-1.358-8.659,2.345-11.068c11.515-7.488,23.548-14.444,35.766-20.677c3.935-2.007,8.754-0.446,10.762,3.491 c2.008,3.935,0.444,8.753-3.491,10.762c-11.722,5.979-23.267,12.653-34.314,19.837 C1157.317,355.437,1155.806,355.855,1154.311,355.855z M1503.43,319.244c-0.955,0-1.925-0.172-2.87-0.535 c-12.29-4.728-24.968-8.85-37.679-12.253c-4.268-1.143-6.801-5.529-5.658-9.797c1.143-4.267,5.526-6.802,9.797-5.659 c13.252,3.549,26.47,7.846,39.284,12.775c4.124,1.585,6.181,6.214,4.595,10.338 C1509.676,317.293,1506.644,319.244,1503.43,319.244z M1226.319,319.129c-3.216,0-6.249-1.954-7.47-5.136 c-1.583-4.125,0.479-8.752,4.604-10.335c12.818-4.918,26.044-9.207,39.31-12.746c4.273-1.143,8.653,1.398,9.792,5.667 c1.139,4.269-1.398,8.653-5.667,9.792c-12.724,3.395-25.41,7.508-37.704,12.225 C1228.242,318.957,1227.273,319.129,1226.319,319.129z M1425.378,298.337c-0.415,0-0.833-0.032-1.255-0.099 c-12.975-2.044-26.235-3.428-39.414-4.113c-4.412-0.23-7.803-3.993-7.574-8.405c0.229-4.412,4.002-7.8,8.405-7.574 c13.731,0.714,27.549,2.157,41.073,4.287c4.364,0.688,7.345,4.783,6.657,9.147 C1432.649,295.523,1429.247,298.337,1425.378,298.337z M1304.404,298.286c-3.872,0-7.275-2.817-7.893-6.762 c-0.685-4.365,2.299-8.458,6.664-9.143c13.521-2.119,27.341-3.55,41.076-4.253c4.415-0.219,8.172,3.169,8.399,7.581 c0.226,4.413-3.168,8.173-7.581,8.398c-13.182,0.675-26.443,2.047-39.416,4.081 C1305.234,298.253,1304.816,298.286,1304.404,298.286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M978.227,680.105c-4.418,0-8-3.582-8-8c0-6.783,0.174-13.646,0.519-20.401 c0.225-4.413,3.97-7.812,8.397-7.583c4.413,0.226,7.807,3.985,7.583,8.397c-0.331,6.485-0.498,13.074-0.498,19.586 C986.227,676.523,982.646,680.105,978.227,680.105z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1086.517,680.105c-4.418,0-8-3.582-8-8c0-6.84,0.245-13.754,0.727-20.551 c0.313-4.407,4.143-7.724,8.546-7.414c4.407,0.313,7.727,4.139,7.414,8.546c-0.456,6.42-0.687,12.954-0.687,19.418 C1094.517,676.523,1090.936,680.105,1086.517,680.105z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1092.853,620.837c-0.562,0-1.132-0.059-1.704-0.183c-4.318-0.937-7.059-5.196-6.122-9.515 c2.882-13.28,6.753-26.466,11.508-39.192c1.546-4.139,6.157-6.239,10.294-4.694c4.139,1.546,6.241,6.155,4.694,10.294 c-4.487,12.009-8.14,24.452-10.86,36.985C1099.85,618.278,1096.536,620.837,1092.853,620.837z M1636.553,620.625 c-3.681,0-6.993-2.555-7.809-6.299c-2.728-12.522-6.389-24.955-10.881-36.955c-1.549-4.138,0.55-8.747,4.688-10.297 c4.135-1.549,8.748,0.55,10.297,4.688c4.76,12.715,8.64,25.89,11.529,39.159c0.94,4.317-1.797,8.579-6.114,9.519 C1637.689,620.565,1637.117,620.625,1636.553,620.625z M1120.542,546.663c-1.299,0-2.616-0.317-3.835-0.985 c-3.875-2.123-5.296-6.984-3.174-10.859c6.516-11.898,13.956-23.443,22.113-34.316c2.652-3.534,7.666-4.249,11.2-1.598 c3.534,2.651,4.25,7.666,1.598,11.2c-7.702,10.267-14.726,21.167-20.878,32.4 C1126.112,545.159,1123.371,546.663,1120.542,546.663z M1608.834,546.527c-2.826,0-5.567-1.502-7.021-4.155 c-6.155-11.224-13.182-22.115-20.884-32.371c-2.653-3.532-1.94-8.547,1.593-11.201c3.532-2.653,8.548-1.94,11.2,1.593 c8.158,10.863,15.6,22.398,22.12,34.287c2.123,3.873,0.705,8.737-3.168,10.861 C1611.453,546.209,1610.135,546.527,1608.834,546.527z M1168.05,483.333c-2.048,0-4.095-0.781-5.658-2.344 c-3.123-3.125-3.122-8.19,0.003-11.314c9.605-9.601,19.98-18.594,30.835-26.73c3.535-2.649,8.549-1.931,11.2,1.604 c2.649,3.535,1.932,8.55-1.604,11.2c-10.251,7.683-20.049,16.176-29.121,25.243 C1172.145,482.553,1170.097,483.333,1168.05,483.333z M1561.312,483.244c-2.046,0-4.091-0.779-5.652-2.338 c-9.077-9.064-18.881-17.555-29.137-25.234c-3.537-2.648-4.257-7.662-1.609-11.199c2.649-3.538,7.663-4.255,11.198-1.608 c10.86,8.132,21.24,17.122,30.851,26.719c3.127,3.122,3.132,8.188,0.01,11.314 C1565.41,482.461,1563.36,483.244,1561.312,483.244z M1231.389,435.876c-2.83,0-5.572-1.504-7.026-4.163 c-2.121-3.875-0.698-8.736,3.178-10.857c11.915-6.52,24.399-12.229,37.104-16.973c4.138-1.543,8.748,0.558,10.293,4.698 c1.545,4.139-0.559,8.747-4.697,10.293c-11.991,4.476-23.774,9.866-35.02,16.019 C1234.003,435.559,1232.687,435.876,1231.389,435.876z M1497.932,435.805c-1.297,0-2.611-0.316-3.829-0.981 c-11.26-6.153-23.056-11.54-35.061-16.013c-4.14-1.541-6.246-6.149-4.704-10.289c1.543-4.14,6.147-6.249,10.29-4.704 c12.72,4.739,25.217,10.447,37.146,16.966c3.878,2.119,5.303,6.978,3.185,10.856 C1503.506,434.298,1500.762,435.805,1497.932,435.805z M1305.505,408.212c-3.685,0-6.999-2.559-7.811-6.306 c-0.936-4.318,1.806-8.577,6.123-9.513c13.238-2.869,26.832-4.811,40.403-5.772c4.402-0.312,8.233,3.008,8.545,7.415 s-3.008,8.233-7.415,8.545c-12.814,0.907-25.647,2.741-38.143,5.45C1306.637,408.154,1306.066,408.212,1305.505,408.212z  M1423.74,408.168c-0.56,0-1.127-0.059-1.697-0.182c-12.496-2.699-25.33-4.523-38.145-5.421 c-4.408-0.308-7.73-4.131-7.422-8.54c0.309-4.406,4.125-7.728,8.54-7.421c13.572,0.95,27.167,2.882,40.406,5.742 c4.318,0.933,7.064,5.189,6.13,9.508C1430.742,405.605,1427.426,408.168,1423.74,408.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1642.934,680.105c-4.418,0-8-3.582-8-8c0-6.467-0.231-13-0.687-19.418 c-0.313-4.407,3.006-8.233,7.413-8.547c4.417-0.318,8.233,3.007,8.546,7.414c0.482,6.794,0.728,13.708,0.728,20.551 C1650.934,676.523,1647.351,680.105,1642.934,680.105z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1749.813,684.786c-0.032,0-0.064-0.001-0.098-0.001c-1.544-0.03-2.988-0.773-3.911-2.014 l-51.063-68.67c-1.646-2.214-1.186-5.343,1.028-6.99c2.212-1.646,5.343-1.185,6.989,1.027l47.213,63.493l47.015-58.363 c1.732-2.149,4.876-2.486,7.024-0.756c2.149,1.73,2.487,4.875,0.757,7.023l-51.063,63.389 C1752.754,684.102,1751.322,684.786,1749.813,684.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M1086.36,684.786c-0.032,0-0.064-0.001-0.096-0.001c-1.545-0.03-2.99-0.773-3.912-2.014 l-51.064-68.67c-1.646-2.214-1.186-5.343,1.028-6.99c2.214-1.646,5.344-1.186,6.99,1.027l47.213,63.493l47.015-58.363 c1.73-2.148,4.875-2.488,7.024-0.756c2.148,1.73,2.487,4.875,0.756,7.023l-51.064,63.389 C1089.302,684.102,1087.871,684.786,1086.36,684.786z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2101.58,1762.211v20.26c0,7.914-6.418,14.334-14.334,14.334h-247.27 c-7.915,0-14.334-6.42-14.334-14.334v-20.26c0-3.527,1.27-6.754,3.385-9.252c2.633-3.109,6.561-5.082,10.949-5.082h247.27 c4.389,0,8.316,1.973,10.949,5.082C2100.311,1755.457,2101.58,1758.684,2101.58,1762.211z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.348,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1869.467,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1899.586,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1929.705,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.824,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989.943,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2020.063,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2050.182,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2080.301,
    y: 1747.877,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2098.195,1752.959h-269.168c2.633-3.109,6.561-5.082,10.949-5.082h247.27 C2091.635,1747.877,2095.563,1749.85,2098.195,1752.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2098.195,1791.722h-269.168c2.633,3.108,6.561,5.081,10.949,5.081h247.27 C2091.635,1796.803,2095.563,1794.83,2098.195,1791.722z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2118.876,1713.283v20.26c0,7.914-6.419,14.334-14.334,14.334h-247.271 c-7.915,0-14.334-6.42-14.334-14.334v-20.26c0-3.527,1.271-6.754,3.385-9.253c2.633-3.108,6.562-5.081,10.949-5.081h247.271 c4.388,0,8.316,1.973,10.949,5.081C2117.605,1706.529,2118.876,1709.756,2118.876,1713.283z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1856.642,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1886.762,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1916.881,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1947,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1977.119,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2007.238,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2037.357,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2067.477,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2097.596,
    y: 1698.95,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2115.491,1704.03h-269.169c2.633-3.108,6.562-5.081,10.949-5.081h247.271 C2108.93,1698.949,2112.858,1700.922,2115.491,1704.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2115.491,1742.793h-269.169c2.633,3.109,6.562,5.082,10.949,5.082h247.271 C2108.93,1747.875,2112.858,1745.902,2115.491,1742.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2105.467,1664.441v20.26c0,7.916-6.42,14.334-14.334,14.334h-247.271 c-7.914,0-14.333-6.418-14.333-14.334v-20.26c0-3.527,1.271-6.752,3.385-9.252c2.633-3.109,6.562-5.082,10.948-5.082h247.271 c4.388,0,8.316,1.973,10.949,5.082C2104.195,1657.689,2105.467,1660.914,2105.467,1664.441z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1843.232,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1873.351,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1903.471,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1933.59,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1963.709,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1993.828,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2023.947,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2054.066,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.183,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2084.186,
    y: 1650.109,
    style: {
      fill: "#FABA23"
    },
    width: 7.183,
    height: 48.925
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2102.082,1655.189h-269.169c2.633-3.109,6.562-5.082,10.948-5.082h247.271 C2095.521,1650.107,2099.449,1652.08,2102.082,1655.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2102.082,1693.953h-269.169c2.633,3.108,6.562,5.081,10.948,5.081h247.271 C2095.521,1699.034,2099.449,1697.062,2102.082,1693.953z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2110.985,1616.488v20.259c0,7.915-6.419,14.334-14.334,14.334h-247.271 c-7.914,0-14.334-6.419-14.334-14.334v-20.259c0-3.527,1.271-6.754,3.385-9.253c2.633-3.108,6.561-5.081,10.949-5.081h247.271 c4.388,0,8.316,1.973,10.949,5.081C2109.715,1609.734,2110.985,1612.961,2110.985,1616.488z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.752,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1878.871,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1908.99,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1939.109,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1969.229,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1999.348,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2029.467,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2059.586,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2089.705,
    y: 1602.155,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.925
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2107.601,1607.235h-269.169c2.633-3.108,6.561-5.081,10.949-5.081h247.271 C2101.039,1602.154,2104.968,1604.127,2107.601,1607.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2107.601,1645.999h-269.169c2.633,3.108,6.561,5.081,10.949,5.081h247.271 C2101.039,1651.08,2104.968,1649.107,2107.601,1645.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2080.16,1566.826v20.259c0,7.915-6.418,14.334-14.334,14.334h-247.27 c-7.916,0-14.334-6.419-14.334-14.334v-20.259c0-3.527,1.27-6.754,3.385-9.252c2.633-3.11,6.56-5.083,10.949-5.083h247.27 c4.389,0,8.316,1.973,10.949,5.083C2078.891,1560.072,2080.16,1563.299,2080.16,1566.826z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1817.927,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.046,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1878.165,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.183,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1908.284,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.183,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1938.403,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.183,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1968.523,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1998.642,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2028.762,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2058.881,
    y: 1552.492,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2076.775,1557.574h-269.168c2.633-3.11,6.56-5.083,10.949-5.083h247.27 C2070.215,1552.491,2074.143,1554.464,2076.775,1557.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2076.775,1596.336h-269.168c2.633,3.109,6.56,5.082,10.949,5.082h247.27 C2070.215,1601.418,2074.143,1599.445,2076.775,1596.336z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2110.493,1518.471v20.26c0,7.914-6.419,14.334-14.334,14.334h-247.271 c-7.914,0-14.334-6.42-14.334-14.334v-20.26c0-3.527,1.271-6.754,3.385-9.253c2.633-3.108,6.561-5.081,10.949-5.081h247.271 c4.388,0,8.316,1.973,10.949,5.081C2109.223,1511.717,2110.493,1514.943,2110.493,1518.471z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.26,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1878.379,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1908.498,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1938.617,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1968.736,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1998.855,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2028.975,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2059.094,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2089.213,
    y: 1504.139,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.924
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2107.108,1509.218h-269.169c2.633-3.108,6.561-5.081,10.949-5.081h247.271 C2100.547,1504.137,2104.476,1506.109,2107.108,1509.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2107.108,1547.98h-269.169c2.633,3.109,6.561,5.082,10.949,5.082h247.271 C2100.547,1553.063,2104.476,1551.09,2107.108,1547.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2099.735,1469.395v20.26c0,7.916-6.419,14.334-14.333,14.334h-247.271 c-7.914,0-14.334-6.418-14.334-14.334v-20.26c0-3.527,1.272-6.753,3.385-9.252c2.633-3.109,6.561-5.082,10.949-5.082h247.271 c4.387,0,8.315,1.973,10.948,5.082C2098.465,1462.642,2099.735,1465.867,2099.735,1469.395z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837.502,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1867.621,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1897.74,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1927.859,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1957.979,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1988.098,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2018.217,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2048.336,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2078.455,
    y: 1455.063,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2096.351,1460.142h-269.169c2.633-3.109,6.561-5.082,10.949-5.082h247.271 C2089.789,1455.061,2093.718,1457.033,2096.351,1460.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2096.351,1498.906h-269.169c2.633,3.107,6.561,5.082,10.949,5.082h247.271 C2089.789,1503.988,2093.718,1502.014,2096.351,1498.906z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2114.512,1420.739v20.26c0,7.915-6.418,14.334-14.334,14.334h-247.27 c-7.915,0-14.334-6.419-14.334-14.334v-20.26c0-3.527,1.271-6.753,3.385-9.253c2.633-3.108,6.561-5.08,10.949-5.08h247.27 c4.389,0,8.316,1.972,10.949,5.08C2113.242,1413.986,2114.512,1417.212,2114.512,1420.739z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1852.278,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.183,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1882.398,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1912.517,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1942.637,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1972.756,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2002.875,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.994,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2063.113,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2093.232,
    y: 1406.406,
    style: {
      fill: "#FABA23"
    },
    width: 7.182,
    height: 48.926
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2111.127,1411.486h-269.168c2.633-3.108,6.561-5.08,10.949-5.08h247.27 C2104.566,1406.406,2108.494,1408.378,2111.127,1411.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2111.127,1450.25h-269.168c2.633,3.109,6.561,5.082,10.949,5.082h247.27 C2104.566,1455.332,2108.494,1453.359,2111.127,1450.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9497 -0.3132 0.3132 0.9497 -425.0992 656.5093)",
    style: {
      fill: "#FABA23"
    },
    cx: 1831.026,
    cy: 1651.499,
    rx: 147.569,
    ry: 147.57
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1946.377,1688.752c-20.572,63.705-88.895,98.665-152.6,78.094 c-6.649-2.149-12.989-4.813-18.981-7.949c-10.145-5.289-19.296-11.9-27.327-19.545c-3.039-2.901-5.922-5.947-8.635-9.125 c-19.867-23.311-30.549-53.74-28.886-85.091c0.54-10.265,2.416-20.632,5.726-30.884c15.343-47.51,57.242-79.039,103.977-83.465 c15.927-1.507,32.429,0.133,48.624,5.363c14.021,4.527,26.652,11.365,37.598,19.967c3.309,2.592,6.463,5.345,9.459,8.25 c8.128,7.871,15.063,16.811,20.654,26.51C1952.529,1619.527,1957.342,1654.796,1946.377,1688.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAEE6C"
    },
    d: "M1905.873,1556.117l-167.039,174.109c-19.867-23.311-30.549-53.74-28.886-85.091l109.703-114.349 c15.927-1.507,32.429,0.133,48.624,5.363C1882.297,1540.678,1894.928,1547.516,1905.873,1556.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAEE6C"
    },
    d: "M1935.986,1590.877l-161.19,168.019c-10.145-5.289-19.296-11.9-27.327-19.545l167.863-174.984 C1923.46,1572.238,1930.396,1581.178,1935.986,1590.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1839.157,1536.285c-14.321-1.504-16.937-0.093-23.366,12.609 c1.598-14.148,0.185-16.763-12.609-23.367c14.32,1.504,16.936,0.092,23.365-12.609 C1825.045,1527.238,1826.455,1529.855,1839.157,1536.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1788.476,1763.961c-12.084-1.27-14.291-0.078-19.717,10.64 c1.348-11.937,0.156-14.143-10.641-19.717c12.084,1.269,14.291,0.077,19.717-10.641 C1776.567,1756.328,1777.759,1758.535,1788.476,1763.961z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1926.676,1161.599c-89.307,0-161.963-72.656-161.963-161.962 c0-89.307,72.656-161.962,161.963-161.962c89.306,0,161.961,72.656,161.961,161.962 C2088.637,1088.942,2015.981,1161.599,1926.676,1161.599z M1926.676,845.674c-84.896,0-153.963,69.067-153.963,153.962 c0,84.895,69.067,153.962,153.963,153.962c84.895,0,153.961-69.067,153.961-153.962 C2080.637,914.741,2011.57,845.674,1926.676,845.674z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1926.676,1091.557c-11.874,0-21.5-9.627-21.5-21.5V772.884c0-11.874,9.626-21.5,21.5-21.5 s21.5,9.626,21.5,21.5v297.173C1948.176,1081.93,1938.55,1091.557,1926.676,1091.557z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1926.676,1161.599c-89.307,0-161.963-72.656-161.963-161.962 c0-89.307,72.656-161.962,161.963-161.962c89.306,0,161.961,72.656,161.961,161.962 C2088.637,1088.942,2015.981,1161.599,1926.676,1161.599z M1926.676,845.674c-84.896,0-153.963,69.067-153.963,153.962 c0,84.895,69.067,153.962,153.963,153.962c84.895,0,153.961-69.067,153.961-153.962 C2080.637,914.741,2011.57,845.674,1926.676,845.674z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1926.676,1091.557c-11.874,0-21.5-9.627-21.5-21.5V772.884c0-11.874,9.626-21.5,21.5-21.5 s21.5,9.626,21.5,21.5v297.173C1948.176,1081.93,1938.55,1091.557,1926.676,1091.557z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1928.152,1109.209c-0.277,0-0.557-0.006-0.836-0.016c-6.575-0.256-12.672-3.51-16.546-8.829 l-89.284-114.397c-6.99-9.599-4.874-23.047,4.725-30.037c9.6-6.99,23.047-4.874,30.037,4.725l73.25,92.378l68.641-93.688 c7.713-9.028,21.283-10.094,30.313-2.381c9.027,7.713,10.094,21.285,2.38,30.313l-86.333,114.398 C1940.404,1106.465,1934.426,1109.209,1928.152,1109.209z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M853.356,1145.131c-89.307,0-161.962-72.655-161.962-161.962 c0-89.306,72.656-161.962,161.962-161.962c89.306,0,161.962,72.656,161.962,161.962 C1015.318,1072.475,942.662,1145.131,853.356,1145.131z M853.356,829.207c-84.895,0-153.962,69.067-153.962,153.962 c0,84.896,69.067,153.962,153.962,153.962s153.962-69.066,153.962-153.962C1007.318,898.274,938.251,829.207,853.356,829.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -445.2635 891.3774)",
    style: {
      fill: "#E3EAFF"
    },
    cx: 853.356,
    cy: 983.169,
    rx: 117.209,
    ry: 117.208
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M942.131,1032.363c-17.211,31.322-50.512,52.545-88.772,52.545 c-38.268,0-71.569-21.223-88.78-52.545c10.882-19.365,27.928-34.809,48.479-43.678c-8.785-9.668-14.139-22.501-14.139-36.594 c0-30.063,24.369-54.44,54.44-54.44c30.063,0,54.432,24.377,54.432,54.44c0,14.093-5.354,26.926-14.139,36.594 C914.203,997.554,931.249,1012.998,942.131,1032.363z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M2095.627,1260.881l-67.953-36.545c-1.918,3.563-3.834,7.126-5.75,10.689l0,0 c-2.777,5.166,10.268,17.58,29.139,27.729c18.869,10.147,36.419,14.188,39.197,9.021 C2090.516,1271.3,2095.627,1260.881,2095.627,1260.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M2095.7,1261.658c-2.778,5.166-20.327,1.127-39.197-9.021 c-18.87-10.149-31.915-22.563-29.138-27.729c2.777-5.166,20.328-1.126,39.197,9.021 C2085.434,1244.078,2098.479,1256.493,2095.7,1261.658z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1793.662,1398.219l-68.774,11.17c0.585,3.606,1.171,7.211,1.757,10.818l0,0 c0.85,5.227,17.019,6.951,36.117,3.85c19.099-3.102,33.893-9.854,33.043-15.082 C1795.726,1408.493,1793.662,1398.219,1793.662,1398.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1794.142,1398.735c0.849,5.228-13.945,11.98-33.043,15.082c-19.099,3.103-35.27,1.378-36.117-3.85 c-0.85-5.227,13.943-11.979,33.042-15.083C1777.123,1391.784,1793.293,1393.508,1794.142,1398.735z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1875.83,1277.564l-62.506-30.785c-1.613,3.277-3.229,6.555-4.842,9.832l0,0 c-2.341,4.752,9.833,15.533,27.189,24.083c17.358,8.549,33.326,11.628,35.666,6.876 C1871.553,1287.134,1875.83,1277.564,1875.83,1277.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1875.921,1278.266c-2.341,4.75-18.308,1.672-35.665-6.877 c-17.357-8.549-29.531-19.331-27.19-24.082c2.341-4.752,18.308-1.673,35.665,6.876 C1866.088,1262.73,1878.262,1273.514,1875.921,1278.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M1782.656,1161.438l-71.987,11.691c0.612,3.775,1.226,7.549,1.839,11.324l0,0 c0.889,5.472,17.814,7.275,37.805,4.029c19.99-3.246,35.476-10.315,34.587-15.787 C1784.817,1172.191,1782.656,1161.438,1782.656,1161.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M1783.158,1161.979c0.889,5.473-14.596,12.54-34.586,15.787 c-19.99,3.246-36.916,1.442-37.805-4.029c-0.889-5.473,14.596-12.541,34.586-15.787S1782.27,1156.506,1783.158,1161.979z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1067.849,1403.232H631.29c-19.396,0-35.121-15.725-35.121-35.121v-92.336 c0-19.396,15.724-35.121,35.121-35.121h436.559c19.396,0,35.121,15.725,35.121,35.121v92.336 C1102.97,1387.508,1087.246,1403.232,1067.849,1403.232z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M753.599,1299.074v45.739c0,12.33-9.99,22.32-22.32,22.32h-86.5c-4.54,0-8.77-1.36-12.3-3.7 c-6.03-3.99-10.01-10.84-10.01-18.62v-45.739c0-12.331,9.99-22.32,22.31-22.32h86.5c5.03,0,9.68,1.67,13.41,4.489 C750.099,1285.305,753.599,1291.783,753.599,1299.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M929.912,1340.55H786.377c-10.276,0-18.606-8.331-18.606-18.606l0,0 c0-10.276,8.33-18.605,18.606-18.605h143.535c10.276,0,18.606,8.329,18.606,18.605l0,0 C948.518,1332.219,940.188,1340.55,929.912,1340.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EAD60"
    },
    d: "M1058.067,1340.55h-71.926c-10.276,0-18.606-8.331-18.606-18.606l0,0 c0-10.276,8.33-18.605,18.606-18.605h71.926c10.276,0,18.606,8.329,18.606,18.605l0,0 C1076.673,1332.219,1068.344,1340.55,1058.067,1340.55z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M744.689,1281.243l-112.21,82.191c-6.03-3.99-10.01-10.84-10.01-18.62v-45.739 c0-12.331,9.99-22.32,22.31-22.32h86.5C736.309,1276.754,740.959,1278.424,744.689,1281.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62552"
    },
    d: "M724.577,1341.412c0,8.289-6.719,15.01-15.008,15.01c-8.289,0-15.008-6.721-15.008-15.01 c0-8.289,6.719-15.008,15.008-15.008C717.858,1326.404,724.577,1333.123,724.577,1341.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M742.399,1341.412c0,8.289-6.719,15.01-15.008,15.01c-8.289,0-15.009-6.721-15.009-15.01 c0-8.289,6.72-15.008,15.009-15.008C735.68,1326.404,742.399,1333.123,742.399,1341.412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020205"
    },
    d: "M2331.996,1136.585c8.725-27.315,6.588-53.814-12.577-71.652 c-19.427-18.081-50.567-12.409-50.567-12.409l0,0c-0.002-0.002-21.792-14.203-49.104,4.394 c-27.313,18.6-16.008,43.459-29.011,58.686c-7.701,9.018-34.813,4.742-35.983,39.858c-0.336,10.13,9.709,19.413,19.387,22.423 c17.002,5.285,35.835,1.838,40.09,10.833c14.627,30.925,70.834,31.878,82.826,13.47c3.719-5.709,46.814,17.423,52.439-26.189 C2352.348,1153.898,2324.2,1160.993,2331.996,1136.585z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2220.697,1125.847c-3.537,33.624,15.004,63.136,41.412,65.913 c26.41,2.779,50.686-22.226,54.223-55.851c3.538-33.625-15.003-63.135-41.412-65.914 C2248.512,1067.216,2224.235,1092.223,2220.697,1125.847z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2302.043,1140.017c0.312,2.531,2.616,4.331,5.147,4.02c2.532-0.311,4.331-2.615,4.021-5.146 c-0.312-2.531-2.615-4.332-5.146-4.02C2303.532,1135.182,2301.732,1137.486,2302.043,1140.017z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2264.863,1136.363c0.336,2.74,2.831,4.689,5.571,4.352s4.688-2.831,4.353-5.572c-0.338-2.738-2.832-4.688-5.572-4.351 C2266.475,1131.128,2264.526,1133.623,2264.863,1136.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020205"
    },
    d: "M2261.032,1130.617c0.378-0.047,0.743-0.217,1.03-0.51c4.163-4.262,10.896-2.998,10.965-2.984 c0.939,0.184,1.854-0.426,2.041-1.366c0.188-0.94-0.418-1.853-1.357-2.043c-0.351-0.071-8.633-1.669-14.135,3.964 c-0.672,0.685-0.658,1.787,0.027,2.457C2259.997,1130.52,2260.525,1130.68,2261.032,1130.617z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020205"
    },
    d: "M2313.771,1137.064c0.185-0.023,0.37-0.076,0.547-0.162c0.864-0.419,1.224-1.459,0.806-2.323 c-3.254-6.707-10.141-6.837-10.432-6.84c-0.958-0.007-1.744,0.765-1.752,1.726c-0.007,0.957,0.761,1.74,1.717,1.751 c0.227,0.005,5.051,0.163,7.338,4.881C2312.328,1136.783,2313.053,1137.152,2313.771,1137.064z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE623C"
    },
    d: "M2295.896,1148.495c1.52,3.302,2.72,6.577,4.492,8.819c0.598,0.758,0.482,1.866-0.244,2.5 c-2.998,2.615-9.328,3.403-13.122,3.639c-0.554,0.035-0.726-0.735-0.211-0.941c4.362-1.742,6.552-3.387,7.569-4.354 c0.507-0.483,0.742-1.175,0.653-1.867c-0.206-1.59-0.593-4.82-0.707-7.423C2294.287,1147.971,2295.52,1147.679,2295.896,1148.495 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2260.242,1163.697c-0.359-1.168,0.84-2.198,1.935-1.657c2.784,1.375,7.425,3.548,12.015,5.171 c4.588,1.622,9.563,2.848,12.594,3.529c1.191,0.268,1.477,1.822,0.463,2.506c-3.115,2.1-9.003,4.877-16.036,2.391 C2264.178,1173.148,2261.345,1167.289,2260.242,1163.697z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020205"
    },
    d: "M2221.066,1122.892c30.438,6.383,81.568-8.849,90.275-22.865 c0.832-20.239-25.875-40.002-45.775-37.525S2216.877,1095.572,2221.066,1122.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE623C"
    },
    d: "M2310.658,1213.785c31.325,7.818,84.866,81.012,89.879,135.892 c-17.188,3.559-36.826-10.144-36.826-10.144l-42.556-61.21L2310.658,1213.785z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2340.949,1841.68l16.777-66.081l-41.627-5.729c-1.428,31.252-3.766,62.021-3.561,70.355 L2340.949,1841.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2241.62,1769.49h-43.464c1.429,10.416,7.129,66.814,7.129,66.814 c3.673,8.334,36.063,6.432,36.063,1.744C2238.899,1827.892,2241.416,1770.791,2241.62,1769.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4204A"
    },
    d: "M2312.689,1795.317l42.863,6.329l29.722-177.74c-6.122-67.453-65.501-210.951-65.501-210.951 l-66.931,23.438l-1.632,63.286l80.602,136.468C2321.306,1662.539,2314.118,1747.867,2312.689,1795.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62552"
    },
    d: "M2279.559,1417.709c-0.612-4.168-0.816-5.47-4.285-7.553l-64.277-18.231l-15.304,15.104 c-14.488,52.608-5.51,125.79,5.917,183.866c-16.732,50.266-10.188,153.885-3.453,202.586h45.709 c2.652-32.555,1.82-92.942,2.024-122.11l0,0c5.917-23.439,11.631-48.441,16.732-74.745c6.53-33.596,14.692-66.151,16.937-96.621 C2281.6,1471.098,2282.211,1440.105,2279.559,1417.709z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2198.48,1205.767c-15.111,9.913-78.801,92.778-43.703,161.024 c1.623,0.902,29.736-46.73,29.736-46.73l33.181-65.689L2198.48,1205.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2230.459,1162.658l39.904,22.662c0,0,3.541,16.156,5.309,21.398 c3.646,10.818-10.328,15.545-22.141,8.811s-19.462-15.743-19.462-15.743L2230.459,1162.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F964F"
    },
    d: "M2329.705,1423.451c0,0-16.467,19.496-19.247,20.957l-14.747-16.102l-0.104,0.276l-3.497,9.212 l-4.09,10.762c-3.422,0-106.254-23.031-106.254-23.031c0.211-9.271,8.927-39.299,23.033-71.266 c-3.422-27.074-0.135-55.219-1.205-70.825c8.305-41.868,2.38-57.942-5.113-77.668l26.091-7.702l46.962,16.561l3.488-11.324 c0,0,29.444,7.063,35.637,10.484l11.125,46.426l-2.409,98.637C2319.374,1358.848,2323.072,1398.564,2329.705,1423.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6A41"
    },
    d: "M2233.641,1192.84l-18.398,7.814c1.941,22.095,51.381,35.299,51.381,35.299l4.908-21.326 L2233.641,1192.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6A41"
    },
    d: "M2271.531,1214.627l14.558,16.174c0,0,12.587-13.018,8.03-21.064 c-4.555-8.047-21.239-13.475-21.239-13.475L2271.531,1214.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M2330.822,1840.613c4.354-11.43,13.66-12.701,13.66-12.701 c18.089,24.127,62.512,9.322,61.041,41.957c-67.553-0.419-95.629,0-95.629,0c0.09-7.496,1.426-25.287,2.982-32.251l3.521,0.626 L2330.822,1840.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M2401.614,1878.581h-87.774c-2.179,0-3.945-1.767-3.945-3.944v-5.666h95.664v5.666 C2405.559,1876.814,2403.793,1878.581,2401.614,1878.581z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6A41"
    },
    d: "M2295.606,1428.583l-3.497,9.212c-3.174-21.196-14.995-109.902-8.324-134.396 c6.26-23.004-1.568-47.258-9.146-70.711c-1.844-5.734-3.766-11.658-5.408-17.402l2.303-0.66l2.294-0.658 c1.624,5.667,3.526,11.553,5.36,17.25c7.789,24.121,15.836,49.064,9.203,73.443 C2282.638,1325.8,2291.459,1398.623,2295.606,1428.583z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M2249.09,1870.186c0,0-5.424-20.232-5.901-22.83c-0.544-2.957-2.138-9.943-2.462-13.526 c-0.081-0.882-9.393-6.577-16.502-6.566c-9.631,0.016-18.408,5.595-18.585,6.649c-1.138,6.752-1.171,14.689-3.013,21.265 c-1.369,4.891-5.092,16.288-5.092,16.288L2249.09,1870.186z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2858"
    },
    d: "M2249.089,1868.613c-1.265,4.016-16.857-0.618-28.235-0.614 c-9.553,0.003-21.914,3.704-23.318,2.263c-2.389,4.219-0.422,12.964-0.422,12.964s9.956,0.515,21.896,0 c11.939-0.515,25.738,0.247,30.937-1.297C2253.226,1876.444,2249.089,1868.613,2249.089,1868.613z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2269.047,1298.631c0,0-82.293,82.496-114.27,68.16c-10.541-14.25,11.844-42.848,32.809-52.43 c20.881-9.543,55.93-24.584,55.93-24.584L2269.047,1298.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CD2D"
    },
    d: "M2284.635,1270.607l34.194-26.385c0.744-0.568,1.69-0.803,2.613-0.647l23.29,4.225 c0.665,0.112,2.027,4.176,1.49,4.584l-23.252,13.973c-0.11,0.085-0.242,0.137-0.381,0.152l-36.556,6.272 C2285.26,1272.866,2284.015,1271.08,2284.635,1270.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9F93A"
    },
    d: "M2286.394,1273.135l32.519-24.822c0.744-0.568,1.69-0.803,2.613-0.646l24.064,4.067 c0.665,0.112,0.873,0.965,0.337,1.372l-22.872,17.342c-0.111,0.085-0.242,0.138-0.381,0.152l-35.729,3.912 C2286.17,1274.597,2285.773,1273.607,2286.394,1273.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2242.624,1290.225l19.214-9.623c0,0,12.18-13.259,15.994-17.221 c4.865-1.415,14.334-5.501,16.266-5.362c1.932,0.138,5.192,1.28,5.192,1.28l-11.12,8.701c0,0,4.532,2.094,10.891-0.449 c6.359-2.543,18.212-10.341,22.775-7.543c1.455,1.868,1.455,1.868,1.455,1.868s4.01-3.102,6.42-0.95 c7.455,6.65-40.633,35.304-40.633,35.304l-20.031,2.401L2242.624,1290.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CD2D"
    },
    d: "M2322.452,1253.641c-1.354,0.927-3.032,0.83-3.749-0.219c-0.716-1.047-0.199-2.646,1.154-3.572 c1.354-0.926,3.033-0.828,3.749,0.219C2324.323,1251.115,2323.807,1252.715,2322.452,1253.641z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE623C"
    },
    d: "M2400.537,1349.677c0,0-42.66,48.782-72.354,55.675c-1.767-9.775-3.391-17.264-3.391-17.264 l40.48-53.291L2400.537,1349.677z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c_4748_",
    style: {
      fill: "#DE623C"
    },
    d: "M2322.787,1408.032c0.14-0.419,0.359-0.788,0.612-1.134 c-0.071-0.021-0.144-0.038-0.214-0.061c-4.215-1.4-6.816-4.984-5.811-8.008c0.164-0.496,0.424-0.94,0.748-1.34 c-2.233-1.731-3.36-4.172-2.643-6.33c0.285-0.857,0.836-1.57,1.564-2.131c-2.343-1.584-3.545-4.233-2.741-6.65 c1.005-3.022,4.737-4.505,8.333-3.309c3.598,1.193,5.699,4.613,4.693,7.635c-0.254,0.766-0.685,1.432-1.242,1.981 c3.516,1.621,5.562,4.809,4.652,7.541c-0.164,0.496-0.424,0.941-0.748,1.341c2.234,1.732,3.361,4.173,2.643,6.331 c-0.264,0.795-0.757,1.469-1.41,2.01c2.145,1.313,3.271,3.652,2.564,5.777c-0.85,2.553-4,3.805-7.038,2.795 C2323.713,1413.473,2321.938,1410.585,2322.787,1408.032z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F37A50"
    },
    d: "M2230.67,1127.896c4.953,7.731,3.839,17.281-2.486,21.334c-6.326,4.053-15.469,1.071-20.42-6.658 c-4.951-7.728-3.838-17.28,2.487-21.333C2216.576,1117.188,2225.719,1120.168,2230.67,1127.896z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE623C"
    },
    d: "M2220.375,1144.645c0.3-0.037,0.596-0.143,0.864-0.321c3.856-2.562,5.489-6.396,4.367-10.255 c-1.147-3.952-4.84-6.879-8.777-6.961c-1.108-0.022-2.025,0.857-2.048,1.965c-0.023,1.109,0.856,2.026,1.965,2.049 c2.157,0.045,4.355,1.832,5.006,4.066c0.625,2.15-0.347,4.206-2.734,5.792c-0.924,0.614-1.174,1.86-0.561,2.782 C2218.892,1144.417,2219.645,1144.733,2220.375,1144.645z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M293.99,1446.027c19.587,35.82,6.427,80.736-29.393,100.323 c-35.82,19.587-80.737,6.427-100.323-29.393c-19.587-35.818-6.427-80.736,29.393-100.322 C229.486,1397.047,274.403,1410.207,293.99,1446.027z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M252.429,1533.976l-6.755-12.353c-7.161,3.756-15.704,5.568-21.657,4.852l-1.545-9.801 c6.008,0.527,13.639-0.627,20.489-4.371c8.684-4.748,11.813-12.975,8.001-19.947c-3.678-6.726-10.723-8.277-21.78-6.998 c-15.151,1.931-25.934,0.518-31.753-10.123c-5.551-10.152-2.548-21.805,7.702-29.793l-6.755-12.354l7.584-4.146l6.488,11.865 c7.473-3.77,13.558-4.555,18.242-4.414l1.356,9.744c-3.371-0.063-9.857-0.012-17.686,4.27 c-9.418,5.148-9.889,12.715-7.213,17.607c3.478,6.361,9.742,7.066,22.792,5.65c15.408-1.752,25.246,1.131,31.198,12.018 c5.284,9.662,3.506,22.393-7.955,31.361l6.956,12.72L252.429,1533.976z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2620.707,1220.848c-17.543,36.864-61.648,52.527-98.513,34.986 c-36.864-17.543-52.528-61.648-34.985-98.512c17.542-36.865,61.647-52.529,98.512-34.986 C2622.585,1139.877,2638.249,1183.983,2620.707,1220.848z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M2525.088,1238.722l6.051-12.714c-7.242-3.6-13.717-9.46-16.625-14.703l7.035-6.996 c3.094,5.178,8.502,10.683,15.551,14.037c8.938,4.254,17.436,1.968,20.85-5.207c3.295-6.924,0.422-13.54-7.096-21.749 c-10.443-11.146-15.619-20.71-10.407-31.661c4.972-10.448,16.173-14.844,28.651-11.221l6.051-12.715l7.805,3.715l-5.811,12.21 c7.434,3.845,11.636,8.316,14.268,12.193l-7.1,6.811c-1.926-2.768-5.769-7.994-13.824-11.827 c-9.693-4.612-16.1-0.56-18.496,4.476c-3.114,6.546-0.014,12.035,8.781,21.779c10.449,11.455,13.881,21.117,8.549,32.32 c-4.731,9.944-16.088,15.965-30.072,11.936l-6.229,13.091L2525.088,1238.722z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M2386.401,469.813c16.456,37.362-0.491,80.991-37.853,97.447 c-37.361,16.456-80.99-0.491-97.446-37.852c-16.456-37.363,0.491-80.991,37.853-97.447 C2326.316,415.505,2369.945,432.452,2386.401,469.813z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2337.481,553.893l-5.675-12.885c-7.457,3.131-16.123,4.206-21.993,2.984l-0.702-9.897 c5.941,1.04,13.643,0.543,20.787-2.605c9.059-3.99,12.878-11.917,9.675-19.189c-3.091-7.017-9.977-9.163-21.103-8.832 c-15.262,0.628-25.884-1.7-30.773-12.799c-4.664-10.589-0.677-21.942,10.218-29.025l-5.675-12.886l7.91-3.484l5.45,12.375 c7.767-3.117,13.897-3.379,18.552-2.84l0.52,9.825c-3.354-0.351-9.82-0.854-17.985,2.743c-9.823,4.327-10.938,11.825-8.69,16.928 c2.922,6.634,9.104,7.871,22.225,7.576c15.502-0.43,25.058,3.283,30.059,14.637c4.439,10.08,1.581,22.61-10.604,30.567 l5.845,13.268L2337.481,553.893z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M91.669,929.384l48.799-91.031c0,0,59.532,5.091,86.857,74.074 c16.938,42.76,74.427,64.946,74.427,64.946l-49.059,91.514c0,0-75.046-20.086-93.583-69.294 C139.506,947.552,91.669,929.384,91.669,929.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M225.417,984.9c-16.178,13.6-42.155,9.323-58.021-9.551c-15.865-18.875-15.612-45.201,0.566-58.799 c16.178-13.6,42.155-9.323,58.02,9.552C241.849,944.977,241.595,971.302,225.417,984.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M2027.115,338.47l-68.686-77.14c0,0,25.263-54.146,99.436-56.069 c45.977-1.192,86.588-47.538,86.588-47.538l69.047,77.547c0,0-44.679,63.554-97.26,64.03 C2060.631,299.803,2027.115,338.47,2027.115,338.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M2125.258,231.987c7.203,19.869-5.75,42.788-28.932,51.191 c-23.181,8.403-47.812-0.892-55.014-20.761c-7.203-19.87,5.75-42.788,28.931-51.192 C2093.424,202.822,2118.055,212.118,2125.258,231.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M2478.288,1495.008l11.214-83.524c0,0,46.942-13.159,87.574,31.722 c25.186,27.818,75.463,28.305,75.463,28.305l-11.273,83.967c0,0-63.09,6.147-91.345-26.141 C2520.04,1495.189,2478.288,1495.008,2478.288,1495.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M2596.373,1499.121c-8.466,15.023-29.537,19.195-47.064,9.318 c-17.526-9.877-24.871-30.063-16.406-45.086c8.467-15.024,29.538-19.195,47.064-9.316 C2597.494,1463.913,2604.84,1484.099,2596.373,1499.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DEFF"
    },
    d: "M1398.583,725.795L1387,639.534c0,0-48.479-13.59-90.442,32.76 c-26.011,28.731-77.935,29.233-77.935,29.233l11.644,86.718c0,0,65.155,6.347,94.336-26.998 C1355.463,725.982,1398.583,725.795,1398.583,725.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1276.629,730.042c8.743,15.516,30.505,19.824,48.606,9.624 c18.101-10.201,25.686-31.048,16.943-46.563c-8.744-15.515-30.505-19.823-48.606-9.623 C1275.472,693.681,1267.886,714.527,1276.629,730.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1067.849,1600.216H631.29c-19.396,0-35.121-15.724-35.121-35.121v-92.335 c0-19.396,15.724-35.121,35.121-35.121h436.559c19.396,0,35.121,15.725,35.121,35.121v92.335 C1102.97,1584.492,1087.246,1600.216,1067.849,1600.216z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6224C"
    },
    d: "M753.599,1496.057v45.74c0,12.33-9.99,22.32-22.32,22.32h-86.5c-4.54,0-8.77-1.359-12.3-3.699 c-6.03-3.99-10.01-10.841-10.01-18.621v-45.74c0-12.33,9.99-22.318,22.31-22.318h86.5c5.03,0,9.68,1.669,13.41,4.488 C750.099,1482.287,753.599,1488.767,753.599,1496.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M929.912,1537.533H786.377c-10.276,0-18.606-8.33-18.606-18.605l0,0 c0-10.276,8.33-18.607,18.606-18.607h143.535c10.276,0,18.606,8.331,18.606,18.607l0,0 C948.518,1529.203,940.188,1537.533,929.912,1537.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EAD60"
    },
    d: "M1058.067,1537.533h-71.926c-10.276,0-18.606-8.33-18.606-18.605l0,0 c0-10.276,8.33-18.607,18.606-18.607h71.926c10.276,0,18.606,8.331,18.606,18.607l0,0 C1076.673,1529.203,1068.344,1537.533,1058.067,1537.533z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62552"
    },
    d: "M744.689,1478.226l-112.21,82.191c-6.03-3.99-10.01-10.841-10.01-18.621v-45.74 c0-12.33,9.99-22.318,22.31-22.318h86.5C736.309,1473.738,740.959,1475.407,744.689,1478.226z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9996 -0.0294 0.0294 0.9996 -44.8828 21.5068)",
    style: {
      fill: "#FAC832"
    },
    cx: 709.569,
    cy: 1538.396,
    rx: 15.008,
    ry: 15.008
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M742.399,1538.396c0,8.289-6.719,15.008-15.008,15.008c-8.289,0-15.009-6.719-15.009-15.008 c0-8.289,6.72-15.008,15.009-15.008C735.68,1523.389,742.399,1530.107,742.399,1538.396z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3EAFF"
    },
    d: "M1067.849,1797.199H631.29c-19.396,0-35.121-15.724-35.121-35.121v-92.335 c0-19.397,15.724-35.12,35.121-35.12h436.559c19.396,0,35.121,15.723,35.121,35.12v92.335 C1102.97,1781.475,1087.246,1797.199,1067.849,1797.199z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA23"
    },
    d: "M753.599,1693.041v45.74c0,12.33-9.99,22.319-22.32,22.319h-86.5c-4.54,0-8.77-1.358-12.3-3.699 c-6.03-3.99-10.01-10.841-10.01-18.62v-45.74c0-12.33,9.99-22.32,22.31-22.32h86.5c5.03,0,9.68,1.67,13.41,4.49 C750.099,1679.271,753.599,1685.751,753.599,1693.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M929.912,1734.517H786.377c-10.276,0-18.606-8.33-18.606-18.606l0,0 c0-10.276,8.33-18.607,18.606-18.607h143.535c10.276,0,18.606,8.33,18.606,18.607l0,0 C948.518,1726.188,940.188,1734.517,929.912,1734.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EAD60"
    },
    d: "M1058.067,1734.517h-71.926c-10.276,0-18.606-8.33-18.606-18.606l0,0 c0-10.276,8.33-18.607,18.606-18.607h71.926c10.276,0,18.606,8.33,18.606,18.607l0,0 C1076.673,1726.188,1068.344,1734.517,1058.067,1734.517z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD332"
    },
    d: "M744.689,1675.211l-112.21,82.19c-6.03-3.99-10.01-10.841-10.01-18.62v-45.74 c0-12.33,9.99-22.32,22.31-22.32h86.5C736.309,1670.721,740.959,1672.391,744.689,1675.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62552"
    },
    d: "M724.577,1735.38c0,8.289-6.719,15.009-15.008,15.009c-8.289,0-15.008-6.72-15.008-15.009 c0-8.288,6.719-15.008,15.008-15.008C717.858,1720.372,724.577,1727.092,724.577,1735.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A6DB"
    },
    d: "M742.399,1735.38c0,8.289-6.719,15.009-15.008,15.009c-8.289,0-15.009-6.72-15.009-15.009 c0-8.288,6.72-15.008,15.009-15.008C735.68,1720.372,742.399,1727.092,742.399,1735.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundPolicy);
export default __webpack_public_path__ + "static/media/refund-policy.66adda210ff16b71635c01d8d65c9848.svg";
export { ForwardRef as ReactComponent };